/* LSL · Fiches produit (mises en page C et A) : barre d'achat du bas, aide au choix « Pas sûr ? »,
   total dans le bouton « Ajouter au panier » et compléments du haut de page A.
   Tout pilote le vrai bloc d'achat : choix de version = clic sur la vraie version,
   « Ajouter au panier » = clic sur le vrai bouton (Kaching, cadeaux et mallette compris).
   Total affiché = prix de la formule Kaching choisie + options cochées (mallette), lus dans le bloc d'achat. */
(() => {
  'use strict';
  const sec = document.querySelector('.shopify-section--main-product');
  if (!sec || window.__lslPa) return;
  window.__lslPa = true;
  const hero = document.querySelector('.lsl-pa-hero');
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const el = (tag, cls, html) => { const e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; };
  const num = (t) => { const s = String(t || '').replace(/[^\d,.]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'); const n = parseFloat(s); return isNaN(n) ? null : n; };
  const money = (n) => n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const textOf = (node) => node ? [...node.childNodes].filter((n) => !(n.nodeType === 1 && n.classList.contains('sr-only'))).map((n) => n.textContent).join('').trim() : '';
  const nameOf = (label) => { if (!label) return ''; const s = label.querySelector('span:not([class])'); return (s ? s.textContent : label.textContent).trim(); };
  const atc = () => sec.querySelector('.product-info .buy-buttons button[type="submit"]');
  const go = (target) => { if (target) target.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' }); };
  const kindOf = (name) => (/proffie/i.test(name) ? 'proffie' : /neo\s*pixel/i.test(name) ? 'neo' : /\brgb\b/i.test(name) ? 'rgb' : '');

  /* Versions de la fiche : { name, kind, input, label } */
  function versionItems() {
    const fs = sec.querySelector('.product-info .lsl-version-selector');
    const inputs = fs ? [...fs.querySelectorAll('input[type="radio"]')] : [];
    return inputs.map((i) => {
      const label = i.id ? sec.querySelector('label[for="' + CSS.escape(i.id) + '"]') : null;
      const name = nameOf(label);
      return { input: i, label, name, kind: kindOf(name) };
    }).filter((x) => x.label);
  }
  const pick = (name) => { const x = versionItems().find((v) => v.name === name); if (x) x.label.click(); };

  /* ---------- Haut de page A (absent en C) ---------- */
  hero?.querySelector('[data-lsl-pa-buy]')?.addEventListener('click', (e) => {
    e.preventDefault();
    go(document.getElementById('acheter') || sec.querySelector('.product-info'));
  });
  function heroBits() {
    if (!hero) return;
    const r = hero.querySelector('[data-lsl-pa-rating]');
    if (r && r.hidden) {
      const src = [...sec.querySelectorAll('.product-info [data-block-type="@app"]')].map((e) => e.innerText || '').find((t) => /\d[.,]\d\s*\(\s*\d+\s*avis\s*\)/i.test(t));
      const m = src && src.match(/(\d[.,]\d)\s*\(\s*(\d+)\s*avis\s*\)/i);
      if (m) { r.innerHTML = '<i aria-hidden="true">★★★★★</i><span><b>' + m[1].replace('.', ',') + '/5</b> · ' + m[2] + ' avis</span>'; r.hidden = false; }
    }
    hero.querySelectorAll('[data-lsl-pa-need]').forEach((a) => { a.hidden = !document.getElementById(a.dataset.lslPaNeed); });
    hero.querySelectorAll('[data-lsl-pa-offer]').forEach((b) => { b.hidden = !document.getElementById('lsl-po-dlg'); });
  }

  /* ---------- Aide au choix « Pas sûr ? » (maquette C), seulement avec les versions de la fiche ---------- */
  let guideKey = '';
  function guideAnswers(items) {
    const by = {}; items.forEach((x) => { if (x.kind && !by[x.kind]) by[x.kind] = x; });
    const price = (x) => num((x.label.querySelector('.lsl-pd-vprice') || {}).textContent);
    const prices = items.map(price).filter((p) => p != null);
    const out = [];
    if (by.rgb) {
      const cheapest = price(by.rgb) != null && prices.length > 1 && price(by.rgb) <= Math.min(...prices);
      out.push({ key: 'combat', label: 'Combattre, s’entraîner', html: '<b>Le RGB.</b> La lame n’a pas d’électronique : c’est la version qui supporte le mieux les impacts répétés.' + (cheapest ? ' C’est aussi la moins chère.' : ''), picks: [by.rgb] });
    }
    if (by.neo) out.push({ key: 'expo', label: 'L’allumer, l’exposer', html: '<b>Le NeoPixel.</b> Les LEDs sont dans la lame : l’allumage monte progressivement et la lumière est plus intense. Il convient aux duels légers, pas au combat intensif.', picks: [by.neo] });
    if (by.proffie) out.push({ key: 'perso', label: 'Tout régler soi-même', html: '<b>Le Proffie.</b> ' + (/neo/i.test(by.proffie.name) ? 'Même lame que le NeoPixel, avec une carte programmable' : 'Une carte programmable') + ' : sons, effets et allumage se modifient sur ordinateur.' + (by.neo ? ' Si tu ne comptes pas programmer, le NeoPixel suffit.' : ''), picks: [by.proffie] });
    const gift = [];
    if (by.rgb) gift.push('Pour quelqu’un qui veut <b>se battre avec</b>, prends le RGB.');
    if (by.neo) gift.push('Pour l’effet de l’allumage et <b>l’exposer</b>, prends le NeoPixel.');
    if (by.proffie) gift.push('Le Proffie s’adresse à ceux qui aiment programmer.');
    gift.push('Le sabre arrive prêt à l’emploi, et tu as 30 jours pour le retourner.');
    out.push({ key: 'gift', label: 'L’offrir', html: gift.join(' '), picks: [by.rgb, by.neo].filter(Boolean) });
    return out;
  }
  function guide() {
    const fs = sec.querySelector('.product-info .lsl-version-selector');
    if (!fs || !document.querySelector('link[href*="lsl-pc"]')) return;
    const items = versionItems();
    const kinds = new Set(items.map((x) => x.kind).filter(Boolean));
    if (kinds.size < 2) return;
    const answers = guideAnswers(items);
    let g = fs.querySelector('.lsl-pc-guide');
    const sig = answers.map((a) => a.key + ':' + a.html).join('|');
    if (g && g.dataset.sig === sig) return;
    if (!g) { g = el('div', 'lsl-pc-guide'); fs.append(g); }
    g.dataset.sig = sig;
    g.innerHTML = '<p class="lsl-pc-guide__q">Pas sûr ? Dis-nous à quoi il va servir.</p><div class="lsl-pc-guide__opts" role="group" aria-label="Usage principal"></div><div class="lsl-pc-guide__ans" hidden><p></p><div class="lsl-pc-guide__go"></div></div>';
    const opts = g.querySelector('.lsl-pc-guide__opts');
    const ans = g.querySelector('.lsl-pc-guide__ans');
    const show = (a) => {
      guideKey = a ? a.key : '';
      opts.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.key === guideKey)));
      ans.hidden = !a;
      if (!a) return;
      ans.querySelector('p').innerHTML = a.html;
      const goBox = ans.querySelector('.lsl-pc-guide__go');
      goBox.innerHTML = '';
      a.picks.forEach((x) => {
        const b = el('button', null, a.picks.length > 1 ? x.name.replace(/^Proffie NeoPixel$/i, 'Proffie') : 'Choisir le ' + x.name.replace(/^Proffie NeoPixel$/i, 'Proffie'));
        b.type = 'button';
        b.addEventListener('click', () => pick(x.name));
        goBox.append(b);
      });
    };
    answers.forEach((a) => {
      const b = el('button', null, a.label);
      b.type = 'button';
      b.dataset.key = a.key;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', () => show(guideKey === a.key ? null : a));
      opts.append(b);
    });
    show(answers.find((a) => a.key === guideKey) || null);
  }

  /* ---------- Haut de fiche de la maquette C : sur-titre, note, « Dans le colis », carte des cadeaux ---------- */
  const isC = !!document.querySelector('link[href*="lsl-pc"]');
  const pcData = document.getElementById('lsl-pc-data');
  function pcTop() {
    if (!isC) return;
    const pi = sec.querySelector('safe-sticky.product-info');
    if (!pi) return;
    const d = pcData ? pcData.dataset : {};
    if (d.eyebrow && !pi.querySelector(':scope > .lsl-pc-eyebrow')) { const p = el('p', 'lsl-pc-eyebrow'); p.textContent = d.eyebrow; pi.append(p); }
    if (!pi.querySelector(':scope > .lsl-pc-rating')) {
      const src = [...pi.querySelectorAll('[data-block-type="@app"]')].map((e) => e.innerText || '').find((t) => /\d[.,]\d\s*\(\s*\d+\s*avis\s*\)/i.test(t));
      const m = src && src.match(/(\d[.,]\d)\s*\(\s*(\d+)\s*avis\s*\)/i);
      if (m) { const a = el('a', 'lsl-pc-rating', '<i aria-hidden="true">★★★★★</i><span></span>'); a.href = '#avis'; a.querySelector('span').textContent = m[1].replace('.', ',') + '/5 · ' + m[2] + ' avis sur ce ' + (d.kind === 'sabre' ? 'sabre' : 'produit'); pi.append(a); }
    }
    const cmp = sec.querySelector('.lsl-pd-compare');
    const nv = versionItems().length;
    if (cmp && nv > 1) { const t = 'Comparer les ' + nv + ' versions'; if (cmp.textContent !== t) cmp.textContent = t; }
    if (d.colis && !pi.querySelector(':scope > .lsl-pc-colis')) {
      const p = el('p', 'lsl-pc-colis', '<b>Dans le colis :</b> ');
      p.append(document.createTextNode(d.colis + ' '));
      if (document.querySelector('.lsl-box')) { const a = el('a', null, 'Voir le coffret'); a.href = '#coffret'; p.append(a); }
      pi.append(p);
    }
    /* Cadeaux : une seule carte, comme sur la maquette (formule unique avec cadeaux offerts) */
    const bars = pi.querySelector('.kaching-bundles__bars');
    const free = bars && bars.children.length === 1 ? [...bars.querySelectorAll('.kaching-bundles__upsell.lsl-pd-free')] : [];
    const on = free.length > 0;
    pi.classList.toggle('lsl-pc-gifts', on);
    let head = pi.querySelector(':scope > .lsl-pc-ohead');
    let foot = pi.querySelector(':scope > .lsl-pc-ofoot');
    if (on) {
      if (!head) { head = el('div', 'lsl-pc-ohead', '<b>Offert avec ta réplique</b>'); if (d.offer) { const s = el('span'); s.textContent = d.offer; head.append(s); } pi.append(head); }
      if (!foot) {
        foot = el('div', 'lsl-pc-ofoot', '<span>Valeur offerte <b></b></span>');
        if (document.getElementById('lsl-po-dlg')) { const b = el('button', null, 'Détails de l’offre'); b.type = 'button'; b.setAttribute('data-lsl-po-open', ''); b.setAttribute('aria-haspopup', 'dialog'); foot.append(b); }
        pi.append(foot);
      }
      const val = free.reduce((s, u) => s + (num((u.querySelector('.kaching-bundles__upsell__full-price') || {}).textContent) || 0), 0);
      const fb = foot.querySelector('b');
      const vt = money(val);
      if (fb.textContent !== vt) fb.textContent = vt;
      free.forEach((u) => {
        const t = u.querySelector('.kaching-bundles__upsell__text');
        if (!t) return;
        const clean = t.textContent.replace(/\s+/g, ' ').trim().replace(/^[^\p{L}\p{N}]+/u, '').replace(/\s*offerte?s?\s*$/i, '').trim();
        if (clean && t.dataset.lslT !== clean) t.dataset.lslT = clean;
      });
    } else { if (head) head.remove(); if (foot) foot.remove(); }
    /* Mallette : « Ajouter la mallette de transport » */
    pi.querySelectorAll('.kaching-bundles__checkbox-upsells__upsell .kaching-bundles__bar-title').forEach((t) => {
      const raw = t.textContent.replace(/\s+/g, ' ').trim();
      if (!raw) return;
      const v = /^mallette/i.test(raw) ? 'Ajouter la ' + raw.toLowerCase() : 'Ajouter : ' + raw;
      if (t.dataset.lslT !== v) t.dataset.lslT = v;
    });
  }

  /* ---------- Barre d'achat du bas ---------- */
  const dock = el('div', 'lsl-pa-dock' + (hero ? '' : ' is-hidden'), '<div class="lsl-pa-dock__seg" role="group" aria-label="Version" hidden></div><span class="lsl-pa-dock__gifts" hidden></span><div class="lsl-pa-dock__sum"><small>Total</small><b></b><em hidden></em></div><button type="button" class="lsl-pa-dock__buy">Ajouter au panier</button>');
  dock.setAttribute('role', 'region');
  dock.setAttribute('aria-label', 'Achat rapide');
  document.body.append(dock);
  document.documentElement.classList.add('lsl-pa');
  const seg = dock.querySelector('.lsl-pa-dock__seg');
  const gifts = dock.querySelector('.lsl-pa-dock__gifts');
  const sumB = dock.querySelector('.lsl-pa-dock__sum b');
  const sumEm = dock.querySelector('.lsl-pa-dock__sum em');
  const buy = dock.querySelector('.lsl-pa-dock__buy');
  buy.addEventListener('click', () => { const b = atc(); if (b && !b.disabled) b.click(); });

  function versions() {
    const items = versionItems();
    if (!items.length) { seg.hidden = true; return; }
    const sig = items.map((x) => x.name).join('|');
    if (seg.dataset.sig !== sig) {
      seg.dataset.sig = sig;
      seg.innerHTML = '';
      items.forEach((x) => {
        const b = el('button', null, x.name.replace(/^Proffie NeoPixel$/i, 'Proffie'));
        b.type = 'button';
        b.dataset.name = x.name;
        b.addEventListener('click', () => pick(x.name));
        seg.append(b);
      });
    }
    seg.hidden = false;
    const byName = new Map(items.map((x) => [x.name, x.input]));
    seg.querySelectorAll('button').forEach((b) => {
      const i = byName.get(b.dataset.name);
      const on = String(!!(i && i.checked));
      if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
      b.disabled = !!(i && i.disabled);
    });
  }

  function totals() {
    const bars = sec.querySelector('.product-info .kaching-bundles__bars');
    const bar = bars && (bars.querySelector(':scope > .kaching-bundles__bar--selected') || (bars.children.length === 1 ? bars.firstElementChild : null));
    const n = bar ? bar.querySelectorAll('.kaching-bundles__upsell.lsl-pd-free').length : 0;
    gifts.hidden = !n;
    const gt = n ? '+ ' + n + (n > 1 ? ' cadeaux offerts' : ' cadeau offert') : '';
    if (gifts.textContent !== gt) gifts.textContent = gt;
    let base = bar ? num((bar.querySelector('.kaching-bundles__bar-price') || {}).textContent) : null;
    if (base == null) {
      const p = num(textOf(sec.querySelector('.product-info__price sale-price')));
      const q = parseInt((sec.querySelector('.product-info .quantity-selector__input') || {}).value, 10) || 1;
      base = p == null ? null : p * q;
    }
    const opts = [...sec.querySelectorAll('.product-info .kaching-bundles__checkbox-upsells__upsell.kaching-bundles__bar--selected')];
    let extra = 0;
    const names = [];
    opts.forEach((o) => { const v = num((o.querySelector('.kaching-bundles__bar-price') || {}).textContent); if (v != null) { extra += v; const t = (o.querySelector('.kaching-bundles__bar-title, [class*="title"]') || {}).textContent; if (t) names.push(t.trim()); } });
    const txt = base == null ? '' : money(base + extra);
    if (sumB.textContent !== txt) sumB.textContent = txt;
    const em = names.length ? 'dont ' + names.join(', ') : '';
    sumEm.hidden = !em;
    if (sumEm.textContent !== em) sumEm.textContent = em;
    const b = atc();
    buy.disabled = !b || b.disabled;
    /* Total dans le vrai bouton « Ajouter au panier » (affiché par lsl-pc.css) */
    const label = b && b.querySelector(':scope > div');
    if (label) { if (txt) { if (label.dataset.lslTotal !== txt) label.dataset.lslTotal = txt; } else if (label.dataset.lslTotal) delete label.dataset.lslTotal; }
  }

  /* La barre se range quand le vrai bouton « Ajouter au panier » est à l'écran */
  let watched = null;
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(([e]) => dock.classList.toggle('is-hidden', e.isIntersecting)) : null;
  function watch() { const b = atc(); if (io && b && b !== watched) { if (watched) io.unobserve(watched); io.observe(b); watched = b; } }

  let queued = 0;
  function apply() {
    queued = 0;
    try { heroBits(); } catch (e) {}
    try { guide(); } catch (e) {}
    try { pcTop(); } catch (e) {}
    try { versions(); } catch (e) {}
    try { totals(); } catch (e) {}
    try { watch(); } catch (e) {}
  }
  const schedule = () => { if (!queued) queued = setTimeout(apply, 60); };
  new MutationObserver(schedule).observe(sec, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] });
  document.addEventListener('variant:change', schedule);
  window.addEventListener('load', schedule);
  apply();
})();
